module.exports = __webpack_public_path__ + "static/img/z10.7c0f2a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z10.png
// module id = Al1E
// module chunks = 0